import { useMemo } from "react"
import {
  NY_GIFT_MY_BEHAVIOR_TYPE,
  useGetNyGiftMyBehaviorQuery
} from "store/apis/nyGiftAPI"
import { dayjsServer } from "utils/dayjsServer"

export const useNyGift = () => {
  const { data: nyGiftMyBehaviorData } = useGetNyGiftMyBehaviorQuery()

  const isVisibleGift = useMemo(() => {
    if (!nyGiftMyBehaviorData) return false

    const isGiftAvailable = dayjsServer().isBefore(
      dayjsServer(nyGiftMyBehaviorData?.gift.claimableTo)
    )

    const isNotNaughty =
      nyGiftMyBehaviorData.gift.yourBehavior !==
      NY_GIFT_MY_BEHAVIOR_TYPE.NAUGHTY

    const isNotClaimed = !nyGiftMyBehaviorData?.gift.claimed

    return isGiftAvailable && isNotNaughty && isNotClaimed
  }, [nyGiftMyBehaviorData])

  const isAvailableToClaimGift = useMemo(() => {
    if (!nyGiftMyBehaviorData) return false

    const isGiftActive = dayjsServer().isAfter(
      dayjsServer(nyGiftMyBehaviorData.gift.claimableFrom)
    )

    return isVisibleGift && isGiftActive
  }, [nyGiftMyBehaviorData, isVisibleGift])

  return {
    nyGiftMyBehaviorData,
    isVisibleGift,
    isAvailableToClaimGift
  }
}
